// HowWeWork.js
import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Users, Shield } from 'lucide-react';

const HowWeWork = () => {
  const steps = [
    {
      id: 1,
      icon: FileText,
      title: "Intake & scope",
      description: "Share your goal, country, and documents"
    },
    {
      id: 2,
      icon: Users,
      title: "Human verification",
      description: "We contact registrars, employers, referees, landlords or neighbors, and where needed, dispatch field agents. Minimum two independent corroborations."
    },
    {
      id: 3,
      icon: Shield,
      title: "Signed report",
      description: "You receive a tamper-evident PDF with sources, timestamps, photos/geo-stamps (for addresses), and a clear verdict: Verified / Inconclusive / Discrepant."
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            How we work
          </h2>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <motion.div
                key={step.id}
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                {/* Step Number & Icon */}
                <div className="flex flex-col items-center mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  {/* <div className="w-8 h-8 bg-acBlack text-white rounded-full flex items-center justify-center text-lg font-bold">
                    {step.id}
                  </div> */}
                </div>

                {/* Content */}
                <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>

                {/* Connector Line (except for last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-gray-200 transform translate-x-8" 
                       style={{ width: 'calc(100% - 4rem)' }}>
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
